<template>
  <div>
    <vs-popup class="trial-expired-popup" title="" button-close-hidden :active="showHardExpired">
      <BuyMeClaim/>
    </vs-popup>

    <GeneralPopup title="" :showPopup="showFirstExperience" componentName="FirstExperience" >
    </GeneralPopup>

    <GeneralPopup title="" :showPopup="showTrialJourneyStarted" componentName="TrialJourneyStarted" :horizontal="true" >
    </GeneralPopup>

    <BuyMePopup ref="buyMePopup"/>
  </div>

</template>

<script>
import BuyMeClaim from './BuyMeClaim'
import BuyMePopup from '@/views/Self-Improvee/Membership/BuyMePopup'
import FirstExperience from '@/views/Self-Improvee/Notifications/FirstExperience'
import { midnight, isPast, daysFromNow } from '@/helpers/date'

export default {
  props: {
  },
  components: {
    BuyMeClaim,
    BuyMePopup,
    FirstExperience,
  },
  data () {
    return {
      showHardExpired: false,
      showFirstExperience: false,
      showTrialJourneyStarted: false
    }
  },
  computed: {
    seenOn () {
      return this.$store.getters.userAdditionalInfo.alreadySeenPopup
    },
    firstExperienceSeen () {
      return this.$store.getters.user.firstExperience
    },
    showTrialJourneyStartedSeen () {
      return this.$store.getters.showTrialJourneyStartedSeen
    },
    activeDays () {
      return this.$store.getters.activeDays
    },
    alreadySeenPopup () {
      if (this.seenOn) {
        return isPast(this.seenOn.toDate())
      } else {
        return false
      }
    },
    resolveShowTrialStartedPopup () {
      return !this.showTrialJourneyStartedSeen && this.$store.getters.userMembership.tarif === 'trial' &&
      this.$store.getters.trialLength > 1 &&
      this.$store.getters.userMembership.endsOn > daysFromNow(2)
    },
  },
  mounted () {
    setTimeout(() => { this.showPopup() },  1000)
  },
  methods: {
    expiredNotification () {
      this.$vs.notify({
          title: 'Your trial membership has expired.',
          text: 'Join thousands of achievers and enjoy unlimited use & all features of improvee.io',
          iconPack: 'feather',
          icon: 'icon-compass',
          time: 5000,
          color: 'purple'
        })

        if (window.smartlook) {
          window.smartlook('track', 'subscriptionExpired', { userId: this.$store.getters.userId })
        }
    },
    showPopup () {
      if (this.$store.getters.hasMembershipExpired) {
        this.expiredNotification()

        if (this.alreadySeenPopup) {
            this.showHardExpired = true
          } else {
          if (!this.seenOn) {
            this.$store.dispatch('ADDITIONAL_USER_INFO', { alreadySeenPopup: midnight() })
          }
          this.$refs.buyMePopup.show()
        }
      } else if (this.resolveShowTrialStartedPopup) {
        this.showTrialJourneyStarted = true

        if (window.smartlook) {
          window.smartlook('track', 'showTrialJourneyStarted', { userId: this.$store.getters.userId })
        }
      }  else if (!this.firstExperienceSeen && this.activeDays > 1 && this.activeDays < 5) {
        this.showFirstExperience = true
        this.$store.dispatch('ADDITIONAL_USER_INFO', { firstExperienceSeen: true })

        if (window.smartlook) {
          window.smartlook('track', 'showFirstExperience', { userId: this.$store.getters.userId })
        }
      }
    }
  }
}
</script>

<style land="scss">

  .trial-expired-popup .vs-popup--header {
    background: #ffffff
  }

 .trial-expired-popup .vs-popup--header {
  display: none;
 }


.trial-expired-popup .vs-popup {
  width: 80% !important;
}

</style>
